export default {
  lng: 'en', //vi|en
  region: 'VN', //vi|pk
  version: '1',
  statusSuccess: 'success',
  domain: 'domain.garena.vn',
  maxFileSize: 6, //MB
  platformIcon: {
    1: 'images/logo-garena.png',
    3: 'images/logo-fb.png',
    5: 'images/logo-vk.png',
    8: 'images/logo-gm.png',
    10: 'images/logo-ap.png',
    11: 'images/logo-x.png',
  },
  hexMap: {
    1: 'brown',
    2: 'brown',
    3: 'brown',
    4: 'purple',
    5: 'purple',
    6: 'purple',
    7: 'purple',
    8: 'purple',
    9: 'special',
    10: 'special',
    11: 'purple',
    12: 'brown',
    13: 'brown',
    14: 'brown',
  }
}